import React from 'react';

import {PrimaryDataText, PrimaryDataTextMedium, SecondaryDataText} from "../../Typography";
import {Box, Grid} from "@material-ui/core";

export const DetailedDataPrimaryItem = ({title, value}) => (
  <>
    <Box width="fit-content">
      <PrimaryDataTextMedium>
        {title}
      </PrimaryDataTextMedium>
    </Box>
    <Box width="fit-content" mt=".6rem">
      <SecondaryDataText>
        {value}
      </SecondaryDataText>
    </Box>
  </>
)
export const DetailedDataSecondaryItem = ({title, value}) => (
  <>
    <Box width="fit-content">
      <SecondaryDataText>
        {title}
      </SecondaryDataText>
    </Box>
    <Box width="fit-content" mt=".6rem">
      <PrimaryDataText>
        {value}
      </PrimaryDataText>
    </Box>
  </>
)

export const detailedDataDisplayCtor = (params) => (props) => {
  const {
    ItemComponent,
    containerProps = {},
    columnProps = {}
  } = params;

  const {
    itemsParamsList = [],
    data = {},
    additionalItems,
  } = props;

  return (
    <Grid container spacing={4} {...containerProps}>
      {itemsParamsList.map((params, index) => {
        if (params.skip && params.skip(data)) return false;

        let title = params.title;

        if (params.titleHandler) {
          title = params.titleHandler(data);
        }

        let value = '';

        if (params.dataHandler) {
          value = params.dataHandler(data);
        } else if (params.key) {
          value = data[params.key];
        }

        return (
          <Grid key={index} item {...columnProps}>
            <ItemComponent
              title={title}
              value={value}
            />
          </Grid>
        )
      })}
      {additionalItems}
    </Grid>
  )
};

export const DetailedDataPrimaryDisplay = detailedDataDisplayCtor({
  ItemComponent: DetailedDataPrimaryItem,
  containerProps: {},
  columnProps: {
    md: 4,
    sm: 6,
    xs: 12
  }
});
export const DetailedDataSecondaryDisplay = detailedDataDisplayCtor({
  ItemComponent: DetailedDataSecondaryItem,
  containerProps: {},
  columnProps: {
    lg: 3,
    md: 4,
    sm: 6,
    xs: 12
  }
});
